import React, { type ImgHTMLAttributes } from "react";
import { responsiveImageProps } from "@/lib/image-delivery";

type Props = ImgHTMLAttributes<HTMLImageElement> & { maxWidth?: number; priority?: boolean };

export function OptimizedImage({ src, maxWidth = 1280, priority = false, sizes, ...props }: Props) {
  return <img
    {...props}
    {...(src ? responsiveImageProps(src, maxWidth) : {})}
    sizes={sizes ?? `(max-width: 768px) 100vw, ${Math.min(maxWidth, 960)}px`}
    loading={priority ? "eager" : props.loading ?? "lazy"}
    decoding="async"
    {...{ fetchpriority: priority ? "high" : "auto" }}
  />;
}
